import { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { signOutAction } from "../../actions/authActions";
import { connect } from "react-redux";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";

class ButtonSendActivationMail extends Component {
    state = {
        showDialog: false,
        dialogTitle: "",
        dialogMessage: "",
    };

    closeDialog = () => {
        this.setState({ showDialog: false });
    };

    sendActivationMail = () => {
        const { useDialog } = this.props;

        axios
            .post(
                `/User/SendActivationMail?email=${encodeURIComponent(
                    this.props.user.email
                )}`
            )
            .then((res) => {
                if (useDialog) {
                    this.setState({
                        showDialog: true,
                        dialogTitle: "Aktiveringsmail skickat - kopiera url:en nedan vid behov",
                        dialogMessage: res.data,
                    });
                } else {
                    toast.success(
                        "Det har skickats ett nytt aktiveringsmail till användaren"
                    );
                }
            })
            .catch((err) => {
                toast.warn(
                    `Det gick inte att skicka ut ett nytt aktiveringsmail till användaren`
                );
            });
    };

    render() {
        const { showDialog, dialogTitle, dialogMessage } = this.state;

        return (
            <>
                <Button
                    outline
                    disabled={this.props.user.activatedAccount}
                    title={
                        this.props.user.activatedAccount
                            ? "Användaren har skapat sitt konto. Har användaren glömt sitt lösenord? Användaren får då använda 'Glömt lösenord'-länken på inloggningssidan för att byta lösenord"
                            : "Användaren har inte aktiverat sitt konto. Klicka här för att skicka ett nytt aktiveringsmail"
                    }
                    size="sm"
                    color="info"
                    className={this.props.leftAlign ? "float-start" : "float-end"}
                    onClick={this.sendActivationMail}
                >
                    <FontAwesomeIcon icon="envelope" className="me-1" />
                    <FontAwesomeIcon icon="retweet" />
                    {this.props.printButtonText ? " Skicka ett nytt aktiveringsmail" : ""}
                </Button>
                <Modal isOpen={showDialog} toggle={this.closeDialog} modalClassName="actmail-width-modal" className="actmail-width-modal">
                    <ModalHeader toggle={this.closeDialog}>{dialogTitle}</ModalHeader>
                    <ModalBody
                        style={{
                            whiteSpace: "normal",
                            overflowWrap: "break-word",
                            wordBreak: "break-all",
                            maxHeight: "60vh",
                            overflowY: "auto",
                            fontFamily: "monospace"
                        }}
                    >
                        {dialogMessage}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={() => navigator.clipboard.writeText(dialogMessage)}>
                            <FontAwesomeIcon icon={faCopy} className="me-2" /> Kopiera
                        </Button>
                        <Button color="primary" onClick={this.closeDialog}>
                            OK
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

export default connect(null, { signOutAction })(ButtonSendActivationMail);
